module.exports = __webpack_public_path__ + "img/routine_web.8ad4d58e.png";